import _castArray from "lodash/castArray";
import _compact from "lodash/compact";

type ID = string | number;
type QueryParams = {[param: string]: string | number | Array<string | number>};

// Transform {a: 1, b: "2", c: [3,"4"]} to "?a=1&b=2&c=3&c=4"
function queryParamsToString(queryParams?: QueryParams): string {
  if (!queryParams) return "";
  return Object.entries(queryParams).reduce(
    (url, [param, values]) =>
      url +
      _castArray(values)
        .map((value) => `${encodeURIComponent(param)}=${encodeURIComponent(value)}`)
        .join("&"),
    "?",
  );
}

class Paths {
  // Root
  root = () => "/";
  host = window.location.origin;
  fullUrl = (path: string) => [this.host, path].join("");
  home = () => "/home";
  help = () => "/help";
  manual = (anchor?: string) =>
    _compact(["https://voicemod.notion.site/Cant-mus-Manual-7872a77102834187beedb57314689683", anchor]).join("#");
  scoreGuidelines = () =>
    "https://voicemod.notion.site/Score-preparation-guidelines-for-Cantamus-9c73c966a82c443bb4064f498b1a4e37";
  // Session
  invitationAccepted = (queryParams?: QueryParams) => `/invitation-accepted${queryParamsToString(queryParams)}`;
  passwordForgotten = () => "/password-forgotten";
  passwordReset = () => "/password-reset";
  signIn = () => "/sign-in";
  signUp = () => "/sign-up";
  signUpInvitation = (userInvitationId: ID) => `/sign-up-invitation/${userInvitationId}`;
  signUpSuccess = () => "/sign-up-success";
  // Catalog
  catalog = () => "/catalog";
  // Ensemble
  ensembles = () => "/ensembles";
  selectedEnsemble = () => "/ensemble";
  // Piece
  pieces = () => "/pieces";
  piece = (pieceId: ID, queryParams?: QueryParams) => `${this.pieces()}/${pieceId}${queryParamsToString(queryParams)}`;
  pieceNewVersion = (pieceId: ID) => `${this.piece(pieceId)}/new-version`;
  pieceNew = () => this.piece("new");
  virtualChoir = (pieceId: ID) => `${this.piece(pieceId)}/virtual-choir`;
  // Rehearsal
  rehearsals = () => "/rehearsals";
  // Ensemble's rehearsal
  ensembleRehearsals = () => "/ensemble-rehearsals";
  // Subscription
  subscription = () => "/subscription";
  subscriptionProcessing = () => "/subscription-processing";
}

export default new Paths();
